import {memo, type ComponentType} from 'react'

import {Tile1} from './_tiles/Tile1'
import {Tile2} from './_tiles/Tile2'
import {Tile3} from './_tiles/Tile3'
import {Tile4} from './_tiles/Tile4'
import {Tile5} from './_tiles/Tile5'
import {Tile6} from './_tiles/Tile6'
import {Tile7} from './_tiles/Tile7'
import type {TileProps} from './_tiles/types'

export type PageDividerTileLayout = '1' | '2' | '3' | '4' | '5' | '6' | '7'

interface PageDividerTileProps {
  layout: PageDividerTileLayout
  colors: readonly [background: `#${string}`, foreground: `#${string}`]
  delay: number
}

const TILE_COMPONENTS = {
  1: Tile1,
  2: Tile2,
  3: Tile3,
  4: Tile4,
  5: Tile5,
  6: Tile6,
  7: Tile7,
} satisfies Record<PageDividerTileLayout, ComponentType<TileProps>>

export const PageDividerTile = memo(function PageDividerTileComponent({layout, colors, delay}: PageDividerTileProps) {
  const Tile = TILE_COMPONENTS[layout]
  return <Tile colors={colors} delay={delay} />
})
